import { subject } from "@casl/ability";
import { FirestoreDataConverter, collection, doc, getDocs, orderBy, query } from "firebase/firestore";
import { getEmpresaDocumentReference } from "../empresas/firestore";

export const RANKING_REGULAMENTO_PER_COLABORADOR_KEY = "rankingRegulamentoPerColaborador";

type TRankingRegulamentoPerColaboradorDocumentReference = TFirestoreDocument<
  TRankingRegulamentoPerColaborador,
  "colaboradorReference"
>;

const colaboradoresConverter: FirestoreDataConverter<TRankingRegulamentoPerColaborador> = {
  toFirestore(data) {
    delete data.id;
    delete data.refPath;
    return data;
  },
  fromFirestore(snap) {
    const { createdAt, updatedAt, colaboradorReference, ...document } =
      snap.data() as TRankingRegulamentoPerColaboradorDocumentReference;

    const data: TRankingRegulamentoPerColaborador = {
      ...document,
      id: snap.id,
      createdAt: createdAt.toDate(),
      refPath: snap.ref.path,
      colaboradorReference: colaboradorReference.path
    };
    if (updatedAt) {
      data.updatedAt = updatedAt.toDate();
    }

    return subject("TRankingRegulamentoPerColaborador", data);
  }
};

/**
 * Get historicoPontosPerColaborador collection reference
 * @param empresaId - Empresa id where the historicoPontosPerColaborador is located
 * @returns - historicoPontosPerColaborador collection reference
 */
function getRankingRegulamentoPerColaboradorCollectionReference(empresaId: TEmpresa["id"]) {
  const empresaDocument = getEmpresaDocumentReference(empresaId);
  return collection(empresaDocument, RANKING_REGULAMENTO_PER_COLABORADOR_KEY);
}

/**
 * Get colaboradores collection reference from the regulamento
 * @param empresaId - Empresa id where the rankingRegulamentoPerColaborador is located
 * @param regulamento - The regulamento to get the colaboradores collection reference
 * @returns - Colaboradores collection reference
 */
function getColaboradoresRankingRegulamentoPerColaboradorCollectionReference(
  empresaId: TEmpresa["id"],
  regulamento: TRegulamentoIdeias
) {
  const rankingColaboradoresCollectionReference = getRankingRegulamentoPerColaboradorCollectionReference(empresaId);
  const documentReference = doc(rankingColaboradoresCollectionReference, regulamento.id);
  return collection(documentReference, "colaboradores");
}

/**
 * Get rankingRegulamentoPerColaborador documents snapshot from the regulamento
 * @param empresaId - Empresa id where the rankingRegulamentoPerColaborador is located
 * @param regulamento - The regulamento to get the rankingRegulamentoPerColaborador document snapshot
 * @returns - RankingRegulamentoPerColaborador documents snapshot
 */
export function getRankingRegulamentoPerColaboradorDocumentsSnapshot(
  empresaId: TEmpresa["id"],
  regulamento: TRegulamentoIdeias
) {
  const colaboradoresCollectionReference = getColaboradoresRankingRegulamentoPerColaboradorCollectionReference(
    empresaId,
    regulamento
  );
  const q = query(colaboradoresCollectionReference, orderBy("rankingByMoedas.ranking")).withConverter(
    colaboradoresConverter
  );
  return getDocs(q);
}
